module.exports = __webpack_public_path__ + "img/end-header-background-ar.e4d1ac48.png";